/* eslint-disable react/jsx-no-useless-fragment */
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import VehicleConditionMap from './VehicleConditionMap';
import { DamageTypesName } from '../../constants/DamageTypes';
import magnifierIcon from '../../assets/img/icons/zoom_red.svg';
import closeIcon from '../../assets/img/icons/close.svg';
import arrowIcon from '../../assets/img/icons/arrow_back.svg';
import cameraIcon from '../../assets/img/icons/camera.svg';

function VehicleDamagesForm({ form }) {
  const { damages } = form?.values?.vehicleDamages || [];
  const [currentDamageIndex, setCurrentDamageIndex] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };
  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => prevIndex + 1);
  };

  useEffect(() => {
    if (currentDamageIndex !== null || currentImageIndex !== null) {
      const escCloser = (e) => {
        const key = e.key || e.code;
        if (key === 'Escape' || key === 'Esc' || e.keyCode === 27) {
          e.preventDefault();
          e.stopPropagation();
          if (currentDamageIndex !== null) {
            setCurrentDamageIndex(null);
            setCurrentImageIndex(null);
          } else if (currentImageIndex !== null) {
            setCurrentImageIndex(null);
          }
        }
      };
      window.addEventListener('keydown', escCloser, true);
      return () => window.removeEventListener('keydown', escCloser, true);
    }
    return undefined;
  }, [currentDamageIndex, currentImageIndex]);

  return (
    <>
      {damages?.length > 0 && (
        <>
          <Row>
            <Col>
              <h4 className="my-2">Damages</h4>
            </Col>
          </Row>
          <VehicleConditionMap
            context="details"
            damages={damages}
            onMapClick={() => {}}
            className="details"
            onMarkerClick={(index) => {
              setCurrentDamageIndex(index);
              setCurrentImageIndex(0);
            }}
          />
          <Row className="w-100 condition-content__header ">
            <h4 className="my-2">Condition inspection – list</h4>
          </Row>
          <Row className="w-100 px-4 g-0 mb-5">
            {damages?.map((item, index) => (
              <div className="condition-content__damage">
                <div className="condition-content__damage-order">{`${index + 1}.`}</div>
                <div className="condition-content__damage-info">
                  <span className="damage-info__type">{DamageTypesName?.[item?.type]}</span>
                  <span className="damage-info__description">{item?.description}</span>
                </div>
                <button
                  type="button"
                  className="condition-content__damage-action"
                  onClick={() => {
                    setCurrentDamageIndex(index);
                    setCurrentImageIndex(0);
                  }}
                >
                  <span className="damage-action__text">Show</span>
                  <img
                    src={magnifierIcon}
                    alt="Red magnifier"
                    className="damage-action__img"
                  />
                </button>
              </div>
            ))}
            <SweetAlert
              showCancel={damages?.length > 1}
              showConfirm={damages?.length > 1}
              show={currentDamageIndex !== null}
              onConfirm={() => {
                setCurrentDamageIndex((prev) => prev - 1);
                setCurrentImageIndex(0);
              }}
              onCancel={() => {
                setCurrentDamageIndex((prev) => prev + 1);
                setCurrentImageIndex(0);
              }}
              closeOnClickOutside={false}
              closeOnEsc={false}
              /* eslint-disable-next-line no-unsafe-optional-chaining */
              cancelBtnCssClass={`common-button red-button ${currentDamageIndex === damages?.length - 1 ? 'damage-alert__btn--hidden' : ''}`}
              cancelBtnText="Next"
              confirmBtnText="Previous"
              customIcon={<img src={closeIcon} alt="Close icon" />}
              confirmBtnCssClass={`common-button red-button ${currentDamageIndex === 0 ? 'damage-alert__btn--hidden' : ''}`}
              title=""
              customClass="damage-alert"
            >
              <div className="sweet-alert__header">
                <span className="sweet-alert-text">Condition Inspection Details</span>
                <button
                  type="button"
                  onClick={() => {
                    setCurrentDamageIndex(null);
                    setCurrentImageIndex(null);
                  }}
                >
                  <img src={closeIcon} alt="Close icon" />
                </button>
              </div>
              <div className="sweet-alert__content">
                <div className="damage-alert__header">
                  <div className="header__counter">{currentDamageIndex + 1}</div>
                  <div className="header__content">
                    <span className="content__damage-type">
                      {DamageTypesName?.[damages?.[currentDamageIndex]?.damageType]}
                    </span>
                    <span className="content__damage-description">
                      {damages?.[currentDamageIndex]?.description}
                    </span>
                  </div>
                </div>

                <div className="slider-container">
                  {currentImageIndex !== 0 && (
                    <button
                      type="button"
                      onClick={handlePrev}
                      className="slider-container__button slider-container__button--back"
                    >
                      <img
                        className="slider-container__button-icon "
                        src={arrowIcon}
                        alt="Arrow back icon"
                      />
                    </button>
                  )}

                  <div className="image-wrapper">
                    {(() => {
                      let src;
                      const damage = damages?.[currentDamageIndex];
                      const photo = damage?.photos?.[currentImageIndex];
                      if (photo) {
                        src = photo.fileUrl;
                      }
                      return <img src={src} alt="slider" className="slider-image" />;
                    })()}
                    <div className="auction-list-item__image-pill image-wrapper__pill">
                      <img src={cameraIcon} alt="Social Media Icon" />
                      <span className="image-pill__counter">
                        {currentImageIndex + 1}/{damages?.[currentDamageIndex]?.photos?.length}
                      </span>
                    </div>
                  </div>

                  {currentImageIndex !==
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    damages?.[currentDamageIndex]?.photos?.length - 1 && (
                    <button
                      type="button"
                      onClick={handleNext}
                      className="slider-container__button slider-container__button--next"
                    >
                      <img
                        className="slider-container__button-icon"
                        src={arrowIcon}
                        alt="Arrow next icon"
                      />
                    </button>
                  )}
                </div>
              </div>
            </SweetAlert>
          </Row>
        </>
      )}
    </>
  );
}

export default VehicleDamagesForm;
